import { render, staticRenderFns } from "./NewUser.vue?vue&type=template&id=6015659a&scoped=true"
import script from "./NewUser.vue?vue&type=script&lang=js"
export * from "./NewUser.vue?vue&type=script&lang=js"
import style0 from "./NewUser.vue?vue&type=style&index=0&id=6015659a&prod&scoped=true&lang=css"
import style1 from "./NewUser.vue?vue&type=style&index=1&id=6015659a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6015659a",
  null
  
)

export default component.exports